import React, {useEffect, useState} from 'react';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import LoadPanel from '../../Components/LoadPanel';
import CompaniesHero from '../../Components/Companies/CompaniesHero';
import {useTranslation} from 'react-i18next';
import {getProjectMembersList} from '../../../redux/actions/projects/projectsActions';
import {mainPath} from '../../../routes/paths';
import {getCompaniesClients} from '../../../redux/actions/clients/clientsActions';
import CustomerInner from '../../Components/Companies/CustomerInner';

const ProjectParticipantsInnerClients = () => {
    const dispatch = useDispatch();
    const {clientId} = useParams();
    const [btnLoading, setBtnLoading] = useState(false);
    const history = useHistory();

    const {profileMe} = useSelector((state) => state.profile);

    const {singleProject} = useSelector((state) => state.projects);

    const editPermission = hasPermission(PERMISSIONS.CUSTOMER_EDIT, profileMe?.permissions ?? []);

    const {companiesClients, companiesClientsLoading} = useSelector((state) => state.clients);

    const {projectMembersList, projectMembersListLoading} = useSelector((state) => state.projects);

    const blockCustomerPermission = hasPermission(PERMISSIONS.CUSTOMER_BLOCK, profileMe?.permissions ?? []);
    const returnCustomerPermission = hasPermission(PERMISSIONS.CUSTOMER_RETURN, profileMe?.permissions ?? []);
    const removePermission = hasPermission(PERMISSIONS.PROJECT_MEMBER_REMOVE, profileMe?.permissions ?? []);
    const allowActions = singleProject?.status === 'active' || singleProject?.status === 'pause'


    const {t} = useTranslation();

    useEffect(() => {
        if (!projectMembersList.length && projectMembersListLoading) {
            dispatch(getProjectMembersList(singleProject.id));
        }
    }, [dispatch, singleProject.id, projectMembersListLoading, projectMembersList]);

    useEffect(() => {
        const fetch = async () => {
            const res = await dispatch(getCompaniesClients(clientId));
            if (!res.payload) {
                handleBack();
            }
        };

        if (Object.keys(singleProject).length > 0) {
            fetch();
        }
    }, [singleProject, clientId]);

    const handleAdd = () => {
        history.push(`${mainPath.projectsParticipantsAdd.replace(':id', singleProject?.id)}`);
    };

    const handleBack = () => {
        history.push(mainPath.projectsParticipants.replace(':id', singleProject?.id));
    };

    const addPermission = hasPermission(PERMISSIONS.PROJECT_MEMBER_ADD, profileMe?.permissions ?? []);
    const viewProjectPermission = hasPermission(PERMISSIONS.MEMBER_PROJECT_LIST, profileMe?.permissions ?? []);

    return (
        <div className={'projects-participants-wrapper'}>
            <div className='projects-participants'>
                <div className='projects-name'>{singleProject.address}</div>

                <CompaniesHero
                    heading={`${projectMembersList?.clients?.length + projectMembersList?.employees?.length} ${t(
                        'ProjectsParticipants.heading'
                    )}`}
                    subHeading={t('ProjectsParticipants.subHeading')}
                    selectedBack={true}
                    handleList={handleBack}
                    selectedList={true}
                    handleAdd={handleAdd}
                    disabledActionAdd={!addPermission || !allowActions}
                />
                {projectMembersListLoading || companiesClientsLoading ? (
                    <LoadPanel noBg={true} circleSize={40} staticPos={true}/>
                ) : (
                    <>
                        <CustomerInner
                            companyId={singleProject.companyId}
                            projectId={singleProject.id}
                            setBtnLoading={setBtnLoading}
                            companiesClients={companiesClients}
                            btnLoading={btnLoading}
                            project={true}
                            handleList={handleBack}
                            editPermission={editPermission && allowActions}
                            viewProjectPermission={viewProjectPermission}
                            blockCustomerPermission={blockCustomerPermission && allowActions}
                            returnCustomerPermission={returnCustomerPermission && allowActions}
                            removePermission={removePermission && allowActions}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default ProjectParticipantsInnerClients;
